import { component } from 'picoapp'
import Splide from '@splidejs/splide'
import $ from 'quantdom'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

export default component(async (node) => {
  const sliderElement = $(node).findEl('.splide')
  const slides = $(node).findEls('.splide__slide')
  const sliderTitle = $(node).attr('data-slider-title')
  const destroyOnDesktop = node.hasAttribute('destroy-on-desktop')
  const marqueeSpeed = (Number(node.dataset.marqueeSpeed) || 25) / 100

  const handleFocusOnArrows = (arrow) => {
    if (arrow) {
      arrow.removeAttribute('disabled')
      arrow.focus()
    }
  }

  const splideOptions = {
    'press-logo-marquee': {
      type: 'loop',
      drag: false,
      autoWidth: true,
      arrows: false,
      perPage: 3,
      gap: '80px',
      pagination: false,
      autoScroll: {
        speed: marqueeSpeed,
        easing: 'linear',
        rewind: false,
        pauseOnHover: true,
        pauseOnFocus: true,
      },
      breakpoints: {
        768: {
          gap: '24px',
        },
      },
    },
    'generic-split-arrow-slider': {
      destroy: destroyOnDesktop ? true : false,
      perPage: 4,
      pagination: false,
      gap: 4,
      arrows: true,
      perMove: 1,
      drag: true,
      breakpoints: {
        768: {
          destroy: false,
          perPage: 2,
        },
      },
    },
    'generic-full-arrow-slider': {
      destroy: destroyOnDesktop ? true : false,
      breakpoints: {
        768: {
          arrows: true,
          pagination: false,
          perPage: 1,
          padding: 20,
          drag: true,
          gap: 8,
          destroy: false,
        },
      },
    },
  }

  if (!sliderElement) return

  const slider = new Splide(sliderElement, splideOptions[node.id])

  if (slides.length > 0) {
    slides.forEach((slide) => {
      $(slide).on('click', () => {
        const collectionTitle = $(slide).attr('data-collection-name')
        if (collectionTitle && window?.gtag) {
          window.gtag('event', `${sliderTitle} - Clicked`, {
            event_detail: collectionTitle,
          })
        }
      })
    })
  }

  slider.on('move', (newIndex, prevIndex) => {
    if (window?.gtag) {
      window.gtag('event', `${sliderTitle} - Moved ${prevIndex < newIndex ? 'Forward' : 'Back'}`)
    }

    const sliderEnd = slider?.Components?.Controller?.getEnd()

    if (newIndex === sliderEnd) {
      const prevArrow = slider?.Components?.Arrows?.arrows?.prev
      handleFocusOnArrows(prevArrow)
    } else if (newIndex === 0) {
      const nextArrow = slider?.Components?.Arrows?.arrows?.next
      handleFocusOnArrows(nextArrow)
    }
  })

  if (splideOptions[node.id]?.autoScroll) {
    window.addEventListener('load', () => {
      slider.mount({ AutoScroll })
    })
  } else {
    slider.mount()
  }
})
